/**
 * The review's family-repeat judgments, by student. A card reads one
 * note's answer with `useFamilyRepeatMoment`. Outside the review there is
 * no provider and every note reads as not similar.
 */
import { createContext, type ReactNode, useContext } from "react"

import {
  type FamilyRepeatMomentView,
  familyRepeatMomentView,
  type FamilyRepeatStudentView,
} from "./useFamilyRepeatJudgment"

const NO_JUDGMENTS: ReadonlyMap<string, FamilyRepeatStudentView> = new Map()

const FamilyRepeatContext =
  createContext<ReadonlyMap<string, FamilyRepeatStudentView>>(NO_JUDGMENTS)

export const FamilyRepeatProvider = ({
  value,
  children,
}: {
  value: ReadonlyMap<string, FamilyRepeatStudentView>
  children: ReactNode
}) => (
  <FamilyRepeatContext.Provider value={value}>
    {children}
  </FamilyRepeatContext.Provider>
)

export const useFamilyRepeatMoment = (
  studentId: string,
  momentId: string
): FamilyRepeatMomentView =>
  familyRepeatMomentView(
    useContext(FamilyRepeatContext).get(studentId),
    momentId
  )
